import { ApiPaymentInformation } from '@bhtp-client-api/base';
import { Address } from './';

export class BillingInformation extends Address {
    public email: string;
    public paymentToken: string;
    public name: string;
    public expMonth: number;
    public expYear: number;
    public last4: string;
    public cardType: string;
    public customerId: string;

    public static toApiPaymentInformation(billingInformation: BillingInformation, merchantProfile: string, paymentMethod: string): ApiPaymentInformation {
        let paymentInfo: ApiPaymentInformation = new ApiPaymentInformation();

        paymentInfo.address = billingInformation.address1;
        paymentInfo.city = billingInformation.city;
        paymentInfo.customerId = billingInformation.customerId;
        paymentInfo.isTest = false;
        paymentInfo.merchantProfile = merchantProfile;
        paymentInfo.nameOnCard = billingInformation.name;
        paymentInfo.paymentMethod = paymentMethod;
        paymentInfo.state = billingInformation.stateOrProvince;
        paymentInfo.paymentToken = billingInformation.paymentToken;
        paymentInfo.zip = billingInformation.postalCode;

        return paymentInfo;
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/shared/models/billing-information.model.ts